import GoalItemDetail from './GoalItemDetail';

export default GoalItemDetail;
